export type OptionTone = 'yes' | 'no' | undefined;

const normalizeOptionValue = (value: string) => value.trim().toLowerCase();

export const getOptionTone = (value?: string): OptionTone => {
  if (!value) return undefined;

  const normalizedValue = normalizeOptionValue(value);

  if (normalizedValue === 'yes' || normalizedValue === 'option1') return 'yes';
  if (normalizedValue === 'no' || normalizedValue === 'option2') return 'no';

  return undefined;
};
